import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [e_commodities] = useParameter<number[]>("@e_commodities");
  const [calendar] = useParameter<number>("@calendar");
  const [e_countries] = useParameter<number[]>("@e_countries");

  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commoditiesGroup, setCommoditiesGroup] = useParameter<number[]>("@commodities_groups");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@business-units": business,
      "@commodities": commodities,
      "@e_commodities": e_commodities,
      "@e_countries": e_countries,
      "@e_calendar": [-1, 0].map((x) => (calendar || 0) + x * 10000).map(String),
      "@commodities_groups": commoditiesGroup,
      "@calendar": calendar,
    });
  }, [title, subtitle, business, e_commodities, e_countries, calendar, commodities, commoditiesGroup, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setBusiness((parameters["@business-units"].value as string[]).map(Number)[0]);
      setCommodities((parameters["@commodities"].value as string[]).map(Number));
      setCommoditiesGroup((parameters["@commodities_groups"].value as string[]).map(Number));
    },
    [setBusiness, setCommodities, setCommoditiesGroup]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
